import AbstractContext from '@/shared/models/AbstractContext';
import StatusBoardColumn from './StatusBoardColumn';
import StatusBoardFilters from './StatusBoardFilters';
import StatusBoardSettings from './StatusBoardSettings';

export default class StatusBoardContext extends AbstractContext {
  columns: Array<StatusBoardColumn> = [];

  constructor(
    readonly filters: StatusBoardFilters,
    readonly settings : StatusBoardSettings,
  ) {
    super();
  }
}